import {
    postRoutePaymentLoading,
    postRoutePaymentRequest,
    postRoutePaymentSuccess,
    postRoutePaymentReject,
    postRoutePaymentReset
} from "../../actions/route/postPayment";

export const postRoutePayment = (formData) => async (dispatch, getState) => {
    dispatch(postRoutePaymentLoading());
    try {
        const { data } = await postRoutePaymentRequest(formData, getState);
        dispatch(postRoutePaymentSuccess(data))
    } catch (error) {
        dispatch(postRoutePaymentReject(error))
    } finally {
        setTimeout(() => { dispatch(postRoutePaymentReset()) }, 3000);
    }
    return Promise.resolve();
};